<script type="text/javascript" charset="UTF-8" src="{{cookieScriptCdn}}"></script>
<div appTheme>
    <div class="header">
        <div class="container">
            <div class="flmid flspacebetween">
                <ng-container>
                    <a  href="{{logoUrlLink}}" target="_blank" rel="noopener" class="logo-brand">
                        <img class="brand headerImage" alt="Logo">
                    </a>
                </ng-container>
            </div>
        </div>
    </div>
</div>

<div class="container start-container">
    <div class="row marginTop">
        <div class="content-body">
            <label class="font16" translate>lblEnterRegistrationNumber</label>
            <div class="loginlp">
                <div class="licence-pl small text-center"  [ngClass]="licensePlateClass">
                    <input type="text" [(ngModel)]="registrationNumber" maxlength="10" (keyup.enter)="authenticateUser()"/>
                </div>
            </div>
            <label [ngClass]="{'lpError': errormessage, 'lpNoError': !errormessage}" translate>{{errormessage}}</label>
            <button class="btn btn-primary btn-block" aria-label="Center Align" (click)="authenticateUser()" translate>lblNext</button>
        </div>
    </div>
</div>